function initLapDrillsSwiper(){
    const Swiper = window.themeCore.utils.Swiper;
    new Swiper('.lap-drills-carousel:not(.swiper-initialized)', {
        slidesPerView: 'auto',
        centeredSlides: true,
        centeredSlidesBounds: false,
        spaceBetween: 20,
        loop: false,
        initialSlide: 0,
        watchSlidesProgress: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    });
};

if (window.themeCore && window.themeCore.loaded) {
    initLapDrillsSwiper();
} else {
    document.addEventListener("theme:all:loaded", initLapDrillsSwiper, { once: true });
}
